import { useState } from 'react';

import Link from 'next/link';
import { useSelector } from 'react-redux';

import { IState } from 'store';
import { IConfigProps } from 'store/modules/config';

import * as S from './styles';

const MAX_BRANDS = 30;

export default function CategoriesMenu() {
  const { categories, brands } = useSelector<IState, IConfigProps>(
    state => state.config,
  );

  const [showAllBrands, setShowAllBrands] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [showCategoriesChildren, setShowCategoriesChildren] = useState(null);
  const [showChildrensChildren, setShowChildrensChildren] = useState(null);

  let maxHeight;
  let maxWidth;

  const visibleBrands = showAllBrands ? brands : brands.slice(0, MAX_BRANDS);

  function changeMenuDimension() {
    setTimeout(() => {
      const menu = document.querySelector('.categories-menu') as HTMLElement;
      const father = document.querySelector(
        `.father-categories-list`,
      ) as HTMLElement;
      const child1 = document.querySelector(
        '.children-categories-list:not(.brand)',
      ) as HTMLElement;
      const child1Brand = document.querySelector(
        `.children-categories-list.brand`,
      ) as HTMLElement;
      const child2 = document.querySelector(
        `.children-childrens-list`,
      ) as HTMLElement;

      if (child2) {
        maxWidth =
          child2.getBoundingClientRect().width +
          child1.getBoundingClientRect().width +
          father.getBoundingClientRect().width;
      } else if (child1) {
        maxWidth =
          child1.getBoundingClientRect().width +
          father.getBoundingClientRect().width;
      } else if (child1Brand) {
        maxWidth =
          child1Brand.getBoundingClientRect().width +
          father.getBoundingClientRect().width;
      } else if (father) {
        maxWidth = father.getBoundingClientRect().width;
      } else {
        maxWidth = 200;
      }

      if (father) father.style.height = `auto`;
      if (child1) child1.style.height = `auto`;
      if (child1Brand) child1Brand.style.height = `auto`;

      maxHeight = Math.max(
        father ? father.scrollHeight : 0,
        child1 ? child1.scrollHeight : 0,
        child2 ? child2.scrollHeight : 0,
      );

      if (menu) menu.style.width = `${maxWidth}px`;
      if (father) father.style.height = `${maxHeight}px`;
      if (child1) child1.style.height = `${maxHeight}px`;
      if (child1Brand) father.style.height = `${maxHeight}px`;
      if (child2) child2.style.height = `${maxHeight}px`;
    }, 5);
  }

  function closeCategories() {
    setShowCategories(false);
    setShowCategoriesChildren(null);
    setShowChildrensChildren(null);
    changeMenuDimension();
    setShowAllBrands(false);
  }

  return (
    <S.Container
      className={`categories-menu ${
        showCategories
          ? showCategoriesChildren
            ? showChildrensChildren
              ? 'show childrens-children'
              : 'show categories-children'
            : 'show categories'
          : ''
      }`}
    >
      <div
        className="categories-menu-header"
        onClick={() => {
          setShowCategories(state => !state);
          setShowCategoriesChildren(null);
          setShowChildrensChildren(null);
          changeMenuDimension();
          setShowAllBrands(false);
        }}
      >
        {showCategories ? (
          <img
            src="/images/icons/x-black.svg"
            alt="Mostrar categorias"
            className="icon x-icon"
          />
        ) : (
          <img
            src="/images/icons/menu-black.svg"
            alt="Mostrar categorias"
            className="icon menu-icon"
          />
        )}
        Categorias
      </div>

      {!!showCategories && (
        <>
          <ul className="father-categories-list">
            {categories.map(fatherCategory => (
              <>
                <li
                  key={fatherCategory.id}
                  className="father-category"
                  onMouseEnter={() => {
                    if (fatherCategory.filhos.length > 0)
                      setShowCategoriesChildren(fatherCategory.id);
                    else setShowCategoriesChildren(null);
                    changeMenuDimension();
                  }}
                  onMouseLeave={() => {
                    changeMenuDimension();
                  }}
                  onClick={() => setShowCategories(false)}
                >
                  <Link
                    href={`/categoria/${fatherCategory.permalink}`}
                    passHref
                  >
                    <a target="_self">
                      <span className="category-name">
                        {fatherCategory.nome}
                      </span>

                      {fatherCategory.filhos.length > 0 ? (
                        <span
                          className="chevron-icon right black"
                          title="Mostrar subcategorias"
                        />
                      ) : (
                        <span className="chevron-icon right transparent" />
                      )}
                    </a>
                  </Link>
                </li>

                {fatherCategory.filhos.length > 0 &&
                  showCategoriesChildren === fatherCategory.id && (
                    <ul className="children-categories-list">
                      {fatherCategory.filhos.map(firstChildrenCategory => (
                        <>
                          <li
                            key={firstChildrenCategory.id}
                            className="children-category"
                            onMouseEnter={() => {
                              if (firstChildrenCategory.filhos.length > 0)
                                setShowChildrensChildren(
                                  firstChildrenCategory.id,
                                );
                              else setShowChildrensChildren(null);
                              changeMenuDimension();
                            }}
                            onMouseLeave={() => {
                              changeMenuDimension();
                            }}
                            onClick={() => setShowCategories(false)}
                          >
                            <Link
                              href={`/categoria/${firstChildrenCategory.permalink}`}
                              passHref
                            >
                              <a target="_self">
                                <span className="category-name">
                                  {firstChildrenCategory.nome}
                                </span>
                                {firstChildrenCategory.filhos.length > 0 ? (
                                  <span
                                    className="chevron-icon right black"
                                    title="Mostrar subcategorias"
                                  />
                                ) : (
                                  <span className="chevron-icon right transparent" />
                                )}
                              </a>
                            </Link>
                          </li>

                          {firstChildrenCategory.filhos.length > 0 &&
                            showChildrensChildren ===
                              firstChildrenCategory.id && (
                              <ul className="children-childrens-list">
                                {firstChildrenCategory.filhos.map(
                                  childrensCategory => (
                                    <li
                                      key={childrensCategory.id}
                                      className="children-categories-list"
                                      onMouseLeave={() => {
                                        changeMenuDimension();
                                      }}
                                      onClick={() => setShowCategories(false)}
                                    >
                                      <Link
                                        href={`/categoria/${childrensCategory.permalink}`}
                                        passHref
                                      >
                                        <a>{childrensCategory.nome}</a>
                                      </Link>
                                    </li>
                                  ),
                                )}
                              </ul>
                            )}
                        </>
                      ))}
                    </ul>
                  )}
              </>
            ))}

            {brands && brands.length > 0 && (
              <>
                <li
                  key={categories.length + 1}
                  className="father-category brands"
                  onMouseEnter={() => {
                    setShowCategoriesChildren(categories.length + 1);
                    changeMenuDimension();
                  }}
                >
                  <div>
                    <span className="category-name">Marcas</span>

                    <span
                      className="chevron-icon right black"
                      title="Mostrar marcas"
                    />
                  </div>
                </li>

                {showCategoriesChildren === categories.length + 1 && (
                  <ul className="children-categories-list brand">
                    {visibleBrands.map(brand => (
                      <li
                        key={brand.id}
                        className="children-category"
                        onMouseLeave={() => {
                          changeMenuDimension();
                        }}
                        onClick={() => setShowCategories(false)}
                      >
                        <Link
                          href={
                            brand.permalink ? `/marca/${brand.permalink}` : '/'
                          }
                          passHref
                        >
                          <a target="_self">
                            <span className="category-name">{brand.nome}</span>
                          </a>
                        </Link>
                      </li>
                    ))}

                    {brands.length > MAX_BRANDS && !showAllBrands && (
                      <li className="children-category show-all-brands">
                        <button
                          onClick={() => {
                            setShowAllBrands(true);
                            changeMenuDimension();
                          }}
                        >
                          Ver mais
                        </button>
                      </li>
                    )}
                  </ul>
                )}
              </>
            )}
          </ul>

          <div
            className="categories-menu-wrapper"
            role="presentation"
            onClick={closeCategories}
          />
        </>
      )}
    </S.Container>
  );
}
